import Helper from '@ember/component/helper';
import pluralize from 'cio/utils/pluralize';
import { roundTimeframe, findRoundUnit } from 'cio/utils/round-timeframe-units';

export function conversionWindowText([model]) {
  let seconds = model.get('conversionWindow');
  let conversionAction = model.get('conversionAction');

  if (seconds > 0) {
    let timeframe = roundTimeframe(seconds);
    let unit = findRoundUnit(timeframe);
    let timeframeValue = Math.ceil(timeframe / unit.seconds);
    let unitLabel = pluralize(timeframeValue, unit.value);

    return `within ${timeframeValue} ${unitLabel} of ${conversionAction}`;
  } else {
    return `any time after ${conversionAction}`;
  }
}

/*
  Basic Usage:

  ```handlebars
  {{conversion-window-text model}}
  ```
*/
export default Helper.helper(conversionWindowText);
